import common from './common.json'

import { ru as customer_catalog } from '@monorepo/customer-catalog_module/translation'

export default {
  ...common,
  customer_catalog,
}
